const convertTo24HourFormat = (timeString) => {
    const [time, period] = timeString.split(" ")
    const [hour, minute] = time.split(":")
    let formattedHour

    if (period === "PM") formattedHour = parseInt(hour) + 12
    else if (hour[0] !== "0") formattedHour = `0${hour}`

    return `${formattedHour}:${minute}`
}

export default convertTo24HourFormat
